export default __webpack_public_path__ + "static/media/safety_icon01.8ee4656e.svg";